/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// LOADER : ROUND
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	round: {
        border: `${pxToEm(10)} solid #f3f3f3`,
        borderRadius: '50%',
        borderTop: `${pxToEm(10)} solid #1494f4`,
        borderBottom: `${pxToEm(10)} solid #1494f4`,
        width: pxToEm(50),
        height: pxToEm(50),
        animation: 'spin 2.2s linear infinite'
    },
    [`@keyframes spin`]: {
        '0%': { transform: 'rotate(0deg)' },
        '100%': { transform: 'rotate(360deg)' }
    }
};